import { securityRepository } from './repository';
import SecurityServiceImpl from './service/SecurityServiceImpl';

const securityService = new SecurityServiceImpl(securityRepository);

export { securityService };
